<template>
  <div
    id="main-container"
    class="main-container"
    :class="
      $store.state.app.collapse ? 'position-collapse-left' : 'position-left'
    "
  >
    <!-- 标签页 -->
    <div class="tab-container">
      <el-tabs
        class="tabs"
        :class="
          $store.state.app.collapse ? 'position-collapse-left' : 'position-left'
        "
        v-model="mainTabsActiveName"
        closable
        type="card"
        @tab-click="selectedTabHandle"
        @tab-remove="removeTabHandle"
        @dblclick.native="fullScreen($event)"
      >
        <el-dropdown class="tabs-tools" :show-timeout="0" trigger="hover">
          <div style="font-size:20px;width:50px;">
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="tabsCloseCurrentHandle"
              >关闭当前标签</el-dropdown-item
            >
            <el-dropdown-item @click.native="tabsCloseOtherHandle"
              >关闭其它标签</el-dropdown-item
            >
            <el-dropdown-item @click.native="tabsCloseAllHandle"
              >关闭全部标签</el-dropdown-item
            >
            <el-dropdown-item @click.native="tabsRefreshCurrentHandle"
              >刷新当前标签</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-tab-pane
          v-for="(item, index) in mainTabs"
          :key="index"
          :label="item.title"
          :name="item.path.substr(0, 1) != '/' ? '/' + item.path : item.path"
        >
          <span slot="label"><i :class="item.icon"></i> {{ item.title }}</span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 主内容区域 -->
    <div ref="main" class="main-content" id="maincontent">
      <transition name="fade" mode="out-in">
        <!-- <keep-alive>
              <router-view ref="content" />
          </keep-alive> -->
        <keep-alive :include="$store.state.tab.key" :exclude="['index']">
          <router-view ref="content"></router-view>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    mainTabs: {
      get() {
        let arr = this.$store.state.tab.mainTabs;
        return this.$tu.distinct(arr, "name");
        // return this.$store.state.tab.mainTabs
      },
      set(val) {
        this.$store.commit("updateMainTabs", val);
      }
    },
    mainTabsActiveName: {
      get() {
        return this.$store.state.tab.mainTabsActiveName;
      },
      set(val) {
        this.$store.commit("updateMainTabsActiveName", val);
      }
    }
  },
  mounted() {},
  methods: {
    fullScreen(e) {
      this.FullScreen(document.getElementById("maincontent"));
    },
    /**
     *张俊娜：2019/12/3
     *描述：全屏退出全屏
     *版本：1.0
     */
    FullScreen(el) {
      const _this = this;
      if (this.isFullscreen) {
        //退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (!document.msRequestFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        //进入全屏
        if (el.requestFullscreen) {
          el.requestFullscreen();
        } else if (el.mozRequestFullScreen) {
          el.mozRequestFullScreen();
        } else if (el.webkitRequestFullscreen) {
          el.webkitRequestFullscreen();
        } else if (el.msRequestFullscreen) {
          this.isFullscreen = true;
          el.msRequestFullscreen();
        }
        _this.$nextTick(() => {
          if (_this.$refs.content.getPie) {
            _this.$refs.content.getPie();
          }
          if (_this.$refs.content.getBar) {
            _this.$refs.content.getBar();
          }
        });
      }
    },
    // tabs, 选中tab
    async selectedTabHandle(tab) {
      console.log(this.$store.state.app.routerLoadSuccess);
      if(this.$store.state.app.routerLoadSuccess < 2) return this.$message.info('动态路由正在加载中稍后再试')
      let tabarr = JSON.parse(JSON.stringify(this.mainTabs));
      tabarr.forEach(elem => {
        elem.path = elem.path.substr(0, 1) != "/" ? "/" + elem.path : elem.path;
      });
      let name = tab.name.substr(0, 1) != "/" ? "/" + tab.name : tab.name;
      let toArr = tabarr.filter(item => item.path == name);
      // tab = this.mainTabs.filter(item => item.path == tab.name)
      localStorage.setItem(
        "storeRoute",
        JSON.stringify({
          path: tab.name.replace("/", ""),
          name: tab.name.replace("/", ""),
          meta: {
            name: tab.label
          }
        })
      );

      // 判断是否为isDrag
      function digui(navTree, path) {
        for (let i = 0; i < navTree.length; i++) {
          const element = navTree[i];
          if (
            path &&
            ((element.url && element.url.includes(path)) ||
              (element.path && element.path.includes(path)))
          )
            return element;
          if (element.children && element.children.length) {
            const result = digui(element.children, path);
            if (result) return result;
          }
        }
      }
      let result = digui(
        this.$store.state.menu.navTree,
        toArr[0].path.substring(1, toArr[0].path.length)
      );
      console.log(result, "查到这个菜单路由了");
      if (result.isDrag === 1) {
        await this.$api.component.XyjPcRoutesPush(this, {
          componentName: result.componentName,
          loadPath: "",
          chinesename: result.name,
          processKey: result.cid ? result.cid : result.processKey,
          tabs: result.lable
        });
        localStorage.setItem("processErrorShow", 0);
      }
      console.log(this.$router.options.routes[0], this.$store.state.app.menuRouteLoaded, 1);
      this.$router.push(toArr[0].path);
      // if (this.$store.state.app.menuRouteLoaded) {
      //   this.$router.push(toArr[0].path);
      // } 
      // else {
      //   let time = null;
      //   let num = 0;
      //   time = setInterval(() => {
      //     console.log(this.$store.state.app.menuRouteLoaded, 2);

      //     if (this.$store.state.app.menuRouteLoaded) {
      //       clearInterval(time);
      //       this.$nextTick(() => {
      //         this.$router.push(toArr[0].path);
      //       });
      //     }
      //     if (num >= 10) {
      //       this.$message.info(`${toArr[0].name}页面，加载失败。`);
      //       clearInterval(time);
      //     }
      //     num++;
      //   }, 500);
      // }

      // // 查路由是否存在
      // let route = digui(
      //   this.$router.options.routes[0].children,
      //   toArr[0].path.substring(1, toArr[0].path.length)
      // );
      // console.log(this.$router.options.routes[0].children,route, "$router");
      // // 未在路由中找到此路由
      // if (!route) {
      //   let num = 0;
      //   let time = null;
      //   time = setInterval(() => {
      //     if (time > 10 && !route) {
      //       clearInterval(time);
      //       this.$router.push("/");
      //       this.$message.info("当前页面不存在已为您跳转至首页");
      //       return;
      //     }

      //     num++;
      //     route = digui(
      //       this.$router.options.routes[0].children,
      //       toArr[0].path.substring(1, toArr[0].path.length)
      //     );
      //     if (route) {
      //       this.$router.push("/" + route.path);
      //       clearInterval(time);
      //     }
      //   }, 500);
      // } else {
      //   this.$router.push("/" + route.path);
      // }
    },
    // tabs, 删除tab
    removeTabHandle(tabName) {
      // 获取当前操作的组件的name值  如果缓存数组中有这个值删除掉
      this.$store.commit(
        "updateKey",
        this.$store.state.tab.key.filter(x => {
          return x != tabName.split("/")[tabName.split("/").length - 1];
        })
      );
      this.mainTabs = this.mainTabs.filter(item => item.path !== tabName);
      // 当前选中tab被删除
      if (tabName === this.mainTabsActiveName) {
        let lasttab = this.mainTabs[this.mainTabs.length - 1];
        if (lasttab) {
          lasttab.name.substr(0, 1) != "/" && (lasttab = "/" + lasttab.name);
        }

        if (tabName != lasttab && this.mainTabs && this.mainTabs.length >= 1) {
          // this.$router.push({ name: this.mainTabs[this.mainTabs.length - 1].name }, () => {
          //   // this.mainTabsActiveName = this.$route.path
          // })-
          let tabPath = this.mainTabs[this.mainTabs.length - 1].path;
          if (tabPath.substr(0, 1) != "/") {
            this.$store.commit(
              "updateMainTabsActiveName",
              "/" + this.mainTabs[this.mainTabs.length - 1].path
            );
          } else {
            this.$store.commit(
              "updateMainTabsActiveName",
              this.mainTabs[this.mainTabs.length - 1].path
            );
          }
          //this.$router.push({path: this.mainTabsActiveName})
          this.$router.push(this.mainTabsActiveName);
        } else {
          this.$store.commit("updateMainTabs", []);
          if (tabName == "/Sys/PCindex") {
            this.mainTabs = [
              {
                icon: "fa fa-indent",
                name: "首页",
                parentName: "系统管理",
                path: "/Sys/PCindex",
                title: "首页"
              }
            ];
            return;
          }
          this.$router.push({ path: "/Sys/PCindex" });
        }
      } else {
        this.$store.commit(
          "updateMainTabs",
          this.mainTabs.filter(elem => elem.path != tabName)
        );
      }
    },
    // tabs, 关闭当前
    tabsCloseCurrentHandle() {
      this.removeTabHandle(this.mainTabsActiveName);
    },
    // tabs, 关闭其它
    tabsCloseOtherHandle() {
      this.mainTabs = this.mainTabs.filter(item =>
        item.path.substr(0, 1) != "/"
          ? "/" + item.path
          : item.path === this.mainTabsActiveName
      );
    },
    // tabs, 关闭全部
    tabsCloseAllHandle() {
      this.mainTabs = [];
      this.$router.push({ path: "/Sys/PCindex" });
    },
    // tabs, 刷新当前
    tabsRefreshCurrentHandle() {
      var tempTabName = this.mainTabsActiveName;
      // 获取当前操作的组件name值
      let data = tempTabName.split("/")[tempTabName.split("/").length - 1];
      // 如果缓存数组中有data去除掉
      this.$store.commit(
        "updateKey",
        this.$store.state.tab.key.filter(x => {
          return x != data;
        })
      );
      this.removeTabHandle(tempTabName);
      this.$nextTick(() => {
        const obj = {
          path:
            tempTabName.substr(0, 1) != "/" ? "/" + tempTabName : tempTabName
        };
        // 添加需要缓存的组件
        this.$store.state.tab.key.push(data);
        // 数组去重
        let ary = Array.from(new Set(this.$store.state.tab.key));
        // 改变vuex里边的缓存数组
        this.$store.commit("updateKey", ary);
        this.$router.push(obj.path);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.main-container {
  padding: 0 5px 5px;
  position: absolute;
  top: 60px;
  left: 1px;
  right: 1px;
  bottom: 0px;
  // background: rgba(56, 5, 114, 0.5);
  .tabs {
    position: fixed;
    top: 60px;
    right: 50px;
    padding-left: 0px;
    padding-right: 2px;
    z-index: 1020;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    background: rgb(255, 253, 255);
    border-color: rgba(200, 206, 206, 0.5);
    // border-left-width: 1px;
    // border-left-style: solid;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }
  .tabs-tools {
    position: fixed;
    top: 60px;
    right: 0;
    z-index: 1020;
    height: 40px;
    // padding: 0 10px;
    font-size: 14px;
    line-height: 40px;
    cursor: pointer;
    border-color: rgba(200, 206, 206, 0.5);
    border-left-width: 1px;
    border-left-style: solid;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    background: rgba(255, 255, 255, 1);
  }
  .tabs-tools:hover {
    background: rgba(200, 206, 206, 1);
  }
  .main-content {
    position: absolute;
    top: 45px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    padding: 5px;
    background-color: #fff;
    // background: rgba(209, 212, 212, 0.5);
  }
}
.position-left {
  left: 200px;
}
.position-collapse-left {
  left: 65px;
}
.el-dropdown {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/MainContent/MainContent.vue